import * as classNames from "classnames"
interface PaywallCheckoutMultiStepsProgressbarProps {
    steps: string[];
    currentStepIndex: number;
}

const PaywallCheckoutMultiStepsProgressbar = (props: PaywallCheckoutMultiStepsProgressbarProps) => {

    const { steps, currentStepIndex } = props;


    const setClassesForStep = (index: number) => {
        if (currentStepIndex > index) {
            return "completed"
        } else if (currentStepIndex === index) {
            return "active"
        } else {
            return "disabled"
        }
    }

    const setClassesForDevider = (index: number) => {
        const isFirst = index === 0;
        const isLast = index === steps.length - 2;
        const isBig = isFirst || isLast;
        const isActive = index < currentStepIndex;

        return `devider ${classNames({ "big": isBig, "right": isFirst, "left": isLast, "active": isActive })}`;
    }

    if (!steps || steps.length === 0 || currentStepIndex == 0) {
        return null;
    }

    return (
        <div className="PaywallCheckoutMultiStepsProgressbar">
            <div className="progressbar-container">
                {
                    steps.map((step, index) => {
                        if (index === 0) return; 
                        return (
                            <div className={`step-container ${setClassesForStep(index)}`} key={step}>
                                <div className="step">{index}</div>
                                <div className="step-title">{step}</div>
                            </div>)
                    })
                }
            </div>
        </div>
    );
};

export default PaywallCheckoutMultiStepsProgressbar;